module.exports = __webpack_public_path__ + "static/media/cvo-road-glide-black-hole.afe951a9.png";